import { GetGuestsOfEventOrganiserQuery } from "../queries";

export const organiserExhibitorsQueryKeys = {
  all: ["organiser-exhibitors"] as const,
  me: () => [...organiserExhibitorsQueryKeys.all, "me"] as const,
  get: (id: string) => [...organiserExhibitorsQueryKeys.all, id] as const,
  getByAdminId: (id: string) =>
    [...organiserExhibitorsQueryKeys.all, id] as const,
  getAsOrganiser: (id: string) =>
    [...organiserExhibitorsQueryKeys.all, id, "as-organiser"] as const,
  getByConnectId: (connectId: string) =>
    [...organiserExhibitorsQueryKeys.all, "connect", connectId] as const,
  event: (id: string) =>
    [...organiserExhibitorsQueryKeys.all, "event", id] as const,
  eventStructures: (eventId: string) =>
    [...organiserExhibitorsQueryKeys.all, "event-structures", eventId] as const,
  eventStructuresPaginated: (eventId: string, filters?: unknown) =>
    [
      ...organiserExhibitorsQueryKeys.eventStructures(eventId),
      "paginated",
      filters,
    ] as const,
};

export const organiserVisitorsQueryKeys = {
  all: ["organiser-visitors"] as const,
  me: () => [...organiserVisitorsQueryKeys.all, "me"] as const,
  event: (eventId: string) =>
    [...organiserVisitorsQueryKeys.all, "event", eventId] as const,
  eventAndQuery: (eventId: string, query?: GetGuestsOfEventOrganiserQuery) =>
    [...organiserVisitorsQueryKeys.all, "event", eventId, query] as const,
  eventAndVisitor: (eventId: string, visitorId: string) =>
    [...organiserVisitorsQueryKeys.all, "event", eventId, visitorId] as const,
  autocomplete: (searchText: string, useName: boolean) =>
    [
      ...organiserVisitorsQueryKeys.all,
      "autocomplete",
      searchText,
      useName,
    ] as const,
};

export const organisersQueryKeys = {
  all: ["organisers"] as const,
  withEvents: () => [...organisersQueryKeys.all, "with-events"] as const,
  pendingPrestationOrders: () => [...organisersQueryKeys.all, "pending-prestation-orders"] as const,
};
